<template>
  <div class="h-full p-8 pb-16 pt-0 w-full overflow-auto">
    <UserProperty
      @dataAvailable="
        data => {
          userData = data || {}
        }
      "
    />
    <div
      class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
    >
      <div class="text-4xl title-color">Validation de store</div>
    </div>
    <div class="py-2"></div>
    <div class="py-4"></div>
    <OtpValidation ref="otpValidator" @otp_validated="onOtpValidated" />

    <UserProperty
      @dataAvailable="
        data => {
          userData = data
        }
      "
      isComponent
    />
    <div class="grid grid-cols-5 gap-12">
      <div
        class="col-span-2 rounded-3xl p-6 bg-white border flex flex-col h-min"
      >
        <div class="text-2xl font-bold text-[#010302]">Documents</div>
        <div class="py-1"></div>
        <div class="text-[#6D6D6D]">Uploadez jusqu'a 6 documents</div>
        <div class="py-3"></div>
        <div class="-mx-6 border-b border-[#E3E5E8]"></div>
        <div class="py-4"></div>
        <div>
          <div
            class="w-full cursor-pointer z-[1] relative"
            @click="
              () => {
                if (files.length < 6) return
                $Events.dispatchEvent('toast_notification', {
                  body: 'Vous ne pouvez pas envoyer plus de 6 fichiers',
                })
              }
            "
          >
            <FileUploader
              :class="{ '!pointer-events-none ': files.length >= 6 }"
              :acceptedFilesTypes="[
                'image/png',
                'image/jpg',
                'image/jpeg',
                'application/pdf',
              ]"
              @onFileChangedV2="data => newFileSelected(data)"
              @uploadFailed="() => uploadFailed()"
              @uploading="data => onUploading(data)"
              :key="filePikerKey"
              exactTypeMatch
              :makeLoadingModal="false"
            >
              <div
                class="flex flex-col items-center cursor-pointer justify-center p-6 border-[0.2rem] #CCCDE3 border-dashed border-gray-100 w-full h-[12vw] rounded-[1.5rem]"
              >
                <div class="w-12 h-12">
                  <img src="@/assets/images/all/image.png" alt="" />
                </div>
                <div class="py-2"></div>
                <p class="font-bold text-lg text-center text-[#010302]">
                  Glisser-déposer, ou
                  <span
                    class="text-primary !cursor-pointer !pointer-events-auto underline"
                  >
                    Parcourir
                  </span>
                </p>
                <p class="text-[#6D6D6D] text-sm mt-1 text-center">
                  jpeg, jpg, png ou pdf.
                  <!-- <br /> -->
                  Taille maximale 10 Mo par document.
                </p>
              </div>
            </FileUploader>
          </div>
        </div>
        <div class="py-6"></div>
        <div v-if="files && files[0]" class="text-[#010302]">
          Fichiers uploadés
        </div>
        <div class="py-3"></div>
        <div class="flex gap-6 flex-col-reverse divide-y-reverse divide-y">
          <div
            v-for="(file, i) in files"
            :key="i"
            class="relative flex gap-4 items-center duration-300 delay-300 pb-6"
            :class="{ 'opacity-50': file.isUploading }"
          >
            <div
              class="w-14 h-14 min-w-14 rounded-lg"
              :class="{ shimmerElementRoundedDefaultnone: file.isUploading }"
            >
              <img
                v-if="file.type == 'application/pdf'"
                src="@/assets/images/files/pdf.png"
                :key="file.url"
                alt=""
                class="w-full h-full object-cover object-center rounded-lg"
              />
              <img
                v-else-if="file.type == 'image/png'"
                src="@/assets/images/files/png.png"
                alt=""
                class="w-full h-full object-cover object-center rounded-lg"
              />
              <img
                v-else-if="file.type == 'image/jpg'"
                src="@/assets/images/files/jpg.png"
                alt=""
                class="w-full h-full object-cover object-center rounded-lg"
              />
              <img
                v-else-if="
                  file.type == 'image/jpeg' && file.name.endsWith('.jpg')
                "
                src="@/assets/images/files/jpg.png"
                alt=""
                class="w-full h-full object-cover object-center rounded-lg"
              />
              <img
                v-else-if="file.type == 'image/jpeg'"
                src="@/assets/images/files/jpeg.png"
                alt=""
                class="w-full h-full object-cover object-center rounded-lg"
              />
            </div>
            <div class="w-[35%] min-w-[35%]">
              <div class="w-full text-[#010302] truncate">
                {{ file.name }}
              </div>
              <div class="text-sm text-[#6D6D6D]">
                {{ file.type.replace(/.+\//, '') }} &bull;
                {{ file.size }}
              </div>
            </div>
            <div
              :class="{ 'opacity-0': !file.isUploading }"
              class="duration-300 delay-500 w-full h-2 bg-slate-100 rounded-full overflow-hidden"
            >
              <div
                class="h-full bg-primary duration-300 rounded-full"
                :style="{
                  width: (!file.isUploading ? 100 : file.progress) + '%',
                }"
              ></div>
            </div>
            <div class="ml-auto cursor-pointer" @click="removePicture(i, file)">
              <div class="text-xl" v-if="file.isUploading">&times;</div>
              <div class="w-6 h-6" v-else>
                <img src="@/assets/images/icons/trash.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="py-2"></div>

        <!-- <div>
          <div>Remarques:</div>
          <div class="py-2"></div>
          <ul class="flex list-disc gap-2 px-8 flex-col">
            <li>Le fichier doit être au format JPEG, JPG ou PNG.</li>
            <li>Chaque fichier doit être moins de 10Mo</li>
            <li>
              Les marges doivent être claires, en couleur ou contenir le nom
              légal de l'entreprise et les informations requises
            </li>
            <li>
              les documents doivent être en cours de validité et ne peuvent pas
              être expirés ou modifiés
            </li>
            <li>
              Type de document suggérer:
              <a href="" class="font-bold">En savoir plus</a>
            </li>
          </ul>
        </div> -->
        <!-- <button
          class="buttonComponent relative  mt-8 arrow w-full"
          @click="finishPicturesSelection"
        >
          continuer
        </button> -->
      </div>
      <div
        class="col-span-3 row-span-2 rounded-3xl p-6 bg-white border flex flex-col min-h-full"
      >
        <div class="text-2xl font-bold text-[#010302]">
          Informations de base
        </div>
        <div class="py-1"></div>
        <div class="text-[#6D6D6D]">
          Les informations d'inscription ne peuvent pas être modifiées moins de
          3 mois après l'approbation de l'inscription
        </div>

        <div class="py-3"></div>
        <FormComponent
          class="w-full grid grid-cols-12 [&_.inputContainer]:!border-[0.15rem] [&_.inputContainer]:!border-[#E8E8E8]"
          :fields="step1FormFields"
          :onFormSubmited="
            data => {
              infoStepFormSubmited(data)
            }
          "
          :loading="false"
        >
          <template #submitButton>
            <button
              class="hidden"
              type="submit"
              ref="companyInfoSubmit"
            ></button>
          </template>
        </FormComponent>
        <!-- <button
          class="buttonComponent  mt-8 arrow w-full"
          @click="$refs.submit.click()"
        >
          continuer
        </button> -->
      </div>
    </div>
    <div class="py-3"></div>
    <div class="flex justify-end">
      <button
        class="buttonComponent relative mt-auto  col-span-2"
        @click="validateInfos"
      >
        Valider
      </button>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import FormComponent from '@/components/utils/FormComponent.vue'
import FileUploader from '@/components/utils/FileUploader.vue'
import InputComponent from '@/components/utils/InputComponent.vue'
import UserProperty from '@/components/user/UserProperty.vue'
import { OtpUtils } from '@/utils/plugins/otpUtils'
import OtpValidation from '@/components/utils/OtpValidation.vue'

export default defineComponent({
  name: 'ProfileContent',
  components: {
    OtpValidation,
    FormComponent,
    FileUploader,
    InputComponent,
    UserProperty,
  },
  props: {},
  data() {
    return {
      filePikerKey: 'none',
      step: 0,
      fileUploaderAvailable: true,
      eventsIds: [],
      files: [],
      step1FormFields: [
        {
          type: 'text',
          propertyName: 'companyName',
          label: "Nom légal de l'entreprise",
          defaultValue: '',
          required: true,
          class: 'col-span-12 !mb-8',
          inputProps: {
            detailText:
              "Saisissez le nom légal de l'entreprise exactement comme il apparait sur les documents commerciaux",
          },
        },
        {
          type: 'select',
          propertyName: 'country',
          label: 'Pays ou région',
          options: this.$Countries.getSignupCountries().sort((ca, cb) => {
            if (ca.countryName > cb.countryName) return 1
            if (ca.countryName < cb.countryName) return -1
            return 0
          }),
          formatOptionInputDisplay(country) {
            return `${country.countryName}`
          },
          formatOptionsDisplay(country) {
            return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
              country.countryName
            }</span></div>`
          },
          inputProps: {
            selectTitle: 'Séléctionnez un pays',
            useModal: false,
            detailText:
              'Choissisez le pays ou la région exactement comme cela apparait sur les documents commerciaux',
          },
          defaultValue: `Bénin`,
          required: true,
          class: 'col-span-12 locationCountry',
        },
        // {
        //   type: "text",
        //   propertyName: "country",
        //   label: "Pays ou région",
        //   defaultValue: "",
        //   required: true,
        //   class: "col-span-12",
        //   inputProps: {
        //     detailText:
        //       "Choissisez le pays ou la région exactement comme cela apparait sur les documents commerciaux",
        //   },
        // },
        {
          type: 'text',
          propertyName: 'addresss',
          label: 'Adresse',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'state',
          label: 'Province ou Etat',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'city',
          label: 'Ville',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'text',
          propertyName: 'postalCode',
          label: 'Code postale',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {},
        },
        {
          type: 'select',
          propertyName: 'countryPrefix',
          options: this.$Countries.get().sort((ca, cb) => {
            if (ca.countryName > cb.countryName) return 1
            if (ca.countryName < cb.countryName) return -1
            return 0
          }),
          formatOptionInputDisplay(country) {
            return `+${country.callingCode}`
          },
          formatOptionsDisplay(country) {
            return `<div class="flex text-lg justify-between w-full items-center h-[30px] relative"><span>${
              country.countryName
            }</div>`
          },
          inputProps: {
            selectTitle: 'Séléctionnez un préfix',
            useModal: false,
            hideSelectedCheck: true,
          },
          label: '',
          defaultValue: `+229`,
          required: true,
          class:
            ' !w-[6rem] relative z-[2] pl-3 locationCountry phonePrefix  [&_.inputContainer]:!bg-transparent [&_.inputContainer]:!border-none [&_.inputContainer]:!text-l [&_.inputContainer]:!absolute [&_.inputContainer]:!pl-3 [&_input]:!p-[0px] countryPrefix',
        },
        {
          type: 'number',
          propertyName: 'phoneNumber',
          label: 'Numéro de télépone',
          defaultValue: '',

          inputProps: {
            allowTrailingZero: true,
            minLenght: 6,
          },
          required: true,
          class:
            'col-span-12 [&_input]:!pl-[7rem] [&_label]:!pl-[6rem] [&_input:focus_~_label]:!pl-[0px]  [&_input:not(.empty)_~_label]:!pl-[0px]',
        },
        {
          type: 'text',
          propertyName: 'commercialLicenceId',
          label: 'Id de licence commerciale',
          defaultValue: '',
          required: true,
          class: 'col-span-12',
          inputProps: {
            detailText:
              "Saisisez l'Id de la licence de l'entreprise exactement comme il apparait sur les documents commerciaus",
          },
        },
        {
          type: 'text',
          propertyName: 'website',
          label: 'Site Web (facultatif)',
          defaultValue: '',
          class: 'col-span-12',
          inputProps: {},
          validate() {
            return ''
          },
        },
      ],
      infoStepFormData: {},
      newFile: '',
      userData: {},
      otpReceived: '',
      displayMessage: '',
      canResendOtp: false,
      otpResendRefreshTimeout: 0,
      otpResetTime: 0,
    }
  },
  mounted() {
    const id = this.$Events.handleEvent(
      'account_validation_info_saved',
      this.accountInfoSaved,
    )
    const id2 = this.$Events.handleEvent(
      'account_validation_info_saving_failed',
      this.accountInfoSavingFailed,
    )
    this.eventsIds.push(id)
    this.eventsIds.push(id2)
  },
  beforeUnmount() {
    this.eventsIds.forEach(this.$Events.removeHandler)
  },
  methods: {
    infoStepFormSubmited(inputData) {
      const countryPrefix =
        inputData.countryPrefix || this.$Countries.find('BJ')
      const phoneNumber = `${countryPrefix.callingCode}${inputData.phoneNumber}`
      const data = JSON.parse(JSON.stringify(inputData))
      const locationCountry = data.locationCountry || this.$Countries.find('BJ')
      data.countryCode = locationCountry?.countryCode || 'BJ'
      data.phoneNumber = phoneNumber
      delete data.countryPrefix
      this.infoStepFormData = data
      // this.step++
      this.finishPicturesSelection()
    },
    newFileSelected({ id, name, url, type, size }) {
      if (this.files[this.files.length - 1]?.isUploading) {
        this.files[this.files.length - 1] = { id, name, url, type, size }
      } else {
        this.files.push({ id, name, url, type, size })
      }
      this.filePikerKey = `${Date.now()}`
      this.fileUploaderAvailable = false
      setTimeout(() => {
        this.fileUploaderAvailable = true
      }, 500)
    },
    uploadFailed() {
      if (this.files[this.files.length - 1]?.isUploading) {
        this.removePicture(this.files.length - 1)
      }
    },
    onUploading(data) {
      if (this.files[this.files.length - 1]?.isUploading) {
        this.files[this.files.length - 1] = { ...data, isUploading: true }
      } else {
        this.files.push({ ...data, isUploading: true })
      }
    },
    removePicture(index, pic) {
      if (pic?.isUploading) {
        this.filePikerKey = `${Date.now()}`
      }
      this.files = this.files.filter((file, i) => i !== index)
      this.$forceUpdate()
    },
    async finishPicturesSelection() {
      if (this.files.length < 2) {
        this.$Events.dispatchEvent('toast_notification', {
          body: 'Veuillez téléverser au moins deux documents de votre entreprise',
        })
        return
      }

      this.validateOtp()
      this.step++
    },
    validateInfos() {
      this.$refs.companyInfoSubmit.click()
    },
    validateOtp() {
      this.$refs.otpValidator.validateEmail({
        email: this.userData?.email,
        firstName: this.userData?.firstName,
      })
    },
    async onOtpValidated() {
      this.$Events.dispatchEvent('account_validation_info_available', {
        ...this.infoStepFormData,
        pictures: this.files,
      })
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Code correct. nous enrégistrons vos informations',
      })
      await new Promise(r => setTimeout(r, 500))

      this.$Events.dispatchEvent('start_loading')
    },
    async accountInfoSaved() {
      await new Promise(r => setTimeout(r, 1000))
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        body: 'Informations Sauvegardé, Nous allons valider votre compte le plus tot',
      })
      this.$router.push('/')
      // this.$Events.dispatchEvent('show_account_activation')
    },
    accountInfoSavingFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        type: 'warning',
        body: "Nous n'avons pas pu enrégistrer vos données, veuillez réessayer.",
      })
    },
  },
  watch: {},
})
</script>
